import React from 'react';
import Skeleton from './Skeleton/Skeleton';
import './StateBlock.css';

export default function StateBlock({
  state = 'empty',
  title,
  message,
  actionLabel,
  onAction,
  children,
}) {
  const isLoading = state === 'loading';
  const role = state === 'error' ? 'alert' : 'status';

  return (
    <div className={`state-block state-block--${state}`} role={role} aria-live={state === 'loading' ? 'polite' : undefined}>
      {children || (isLoading && (
        <div className="state-block__skeletons" aria-hidden="true">
          <Skeleton height="18px" width="60%" />
          <Skeleton height="14px" width="82%" />
          <Skeleton height="14px" width="48%" />
        </div>
      ))}
      {!isLoading && (
        <>
          {title && <h2 className="state-block__title">{title}</h2>}
          {message && <p className="state-block__message">{message}</p>}
          {actionLabel && onAction && (
            <button type="button" className="state-block__action" onClick={onAction}>
              {actionLabel}
            </button>
          )}
        </>
      )}
      {isLoading && title && <span className="visually-hidden">{title}</span>}
    </div>
  );
}
